<template>
  <div class="app-main-content railwayStation">
    <div class="grid-view">
      <div class="main-content">
        <div class="cargo-advance-search-header">
          <div class="cargo-advance-search-toggle-trigger">
            <i
              class="el-icon-arrow-left"
              :style="{ transform: !showAdv ? 'rotate(-90deg)' : 'rotate(90deg)' }"
              @click="upOrDownSearchCondition"
            />
          </div>
          <div v-if="!showAdv" class="cargo-advance-search-quick">
            <el-input
              ref="keyword"
              v-model="filter.likeName"
              style="width:200px;"
              :placeholder="simQueryPlaceholder"
              :spellcheck="false"
              @blur="keyWordBlur"
              @keyup.enter.native.prevent="filter.pageNum=1;toQuery"
            />
          </div>
          <div ref="searchOperations" class="cargo-advance-search-operations">
            <slot name="operations">
              <!--页面操作按钮-->
              <div>
                <el-button :no="'query'" size="mini" type="primary" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }}</el-button>
                <el-button :no="'reset'" size="mini" type="primary" @click="resetSearch()">{{ $t('CargoMsg.Cargo_Reset') }}</el-button>
                <el-button v-if="$checkPermission(['button_FBAChannel_newChannel'])" :no="'new'" size="mini" type="primary" @click="newHandler">{{ $t('common.btn.new') }}</el-button>
                <el-button v-if="$checkPermission(['button_FBAChannel_editChannel'])" :disabled="!selectedData" :no="'edit'" size="mini" type="primary" @click="editHandler">{{ $t('common.btn.edit') }}</el-button>
                <el-button v-if="$checkPermission(['button_FBAChannel_deleteChannel'])" :disabled="!selectedData" :no="'delete'" size="mini" type="danger" @click="toDelete">{{ $t('common.btn.delete') }}</el-button>
                <el-button v-if="$checkPermission(['button_FBAChannel_enableChannel'])" :disabled="!selectedData" :no="'enable'" size="mini" type="primary" @click="toActive('enable')">{{ $t('FbaChannel.enable') }}</el-button>
                <el-button v-if="$checkPermission(['button_FBAChannel_disableChannel'])" :disabled="!selectedData" :no="'disable'" size="mini" type="danger" @click="toActive('disable')">{{ $t('FbaChannel.disable') }}</el-button>
              </div>
            </slot>
          </div>
        </div>
        <div v-if="showAdv" class="cargo-advance-search-more">
          <div class="cargo-advance-search-more-operations">
            <el-form label-width="120px" label-position="right" :inline="true">
              <el-row>
                <el-col :span="12">
                  <el-form-item :label="$t('Menu.CreateDate')">
                    <el-date-picker v-model="filter.beginDate" style="width:128px;" type="date" value-format="yyyy-MM-dd" />&nbsp;{{ $t('Pricing.EndDate') }}
                    <el-date-picker v-model="filter.endDate" style="width:128px;" type="date" value-format="yyyy-MM-dd" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6">
                  <el-form-item :label="$t('FbaChannel.channelName')">
                    <el-input
                      ref="channelName"
                      v-model="filter.likeName"
                      style="width:128px"
                      :placeholder="simQueryPlaceholder"
                      :spellcheck="false"
                      @blur="keyWordBlur"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('FbaChannel.shippingType')">
                    <cargo-advance-select
                      no="shippingType"
                      :select-type="selectTypeNames.local_cache_FbaJobConstants$SHIPPING_TYPES"
                      filterable
                      style="width:128px"
                      :clearable="true"
                      :default-value="filter.shippingType"
                      @parentCallBack="p=>{filter.shippingType=p.value}"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('FbaChannel.chargingMethod')">
                    <cargo-advance-select
                      no="chargingMethod"
                      :select-type="selectTypeNames.local_cache_FbaJobConstants$CHARGING_METHODS"
                      filterable
                      style="width:128px"
                      :clearable="true"
                      :default-value="filter.chargingMethod"
                      @parentCallBack="p=>{filter.chargingMethod=p.value}"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('FbaChannel.destinationDistribution')">
                    <cargo-advance-select
                      no="destinationDistribution"
                      :select-type="selectTypeNames.local_cache_FbaJobConstants$ORDER_DESTINATION_DISTRIBUTION_TYPES"
                      filterable
                      style="width:128px"
                      :clearable="true"
                      :default-value="filter.destinationDistribution + ''"
                      @parentCallBack="p=>{filter.destinationDistribution=Number(p.value)}"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6">
                  <el-form-item :label="$t('FbaChannel.acceptableGoods')">
                    <cargo-advance-select
                      no="acceptableGoods"
                      :select-type="selectTypeNames.basic_data_CargoType"
                      :method-params="{fbaSea: true, fbaAir: true, fbaRailway: true, collectionType: 'or'}"
                      :multiple="true"
                      :default-multiple-value="filter.cargoTypeList instanceof Array ? filter.cargoTypeList : []"
                      filterable
                      style="width:128px"
                      :clearable="true"
                      tag-value="code"
                      @parentCallBack="p=>{filter.cargoTypeList=p.value}"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('FbaChannel.creator')">
                    <cargo-user-select
                      style="width:128px"
                      :default-value="filter.createdBy"
                      @change="p=>{filter.createdBy = p.value}"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('FbaChannel.settlementWeightRoundingRules')">
                    <cargo-advance-select
                      no="settlementWeightRoundingRules"
                      :select-type="selectTypeNames.local_cache_FbaJobConstants$SETTLEMENT_WEIGHT_ROUNDING_RULES"
                      filterable
                      style="width:128px"
                      :clearable="true"
                      :default-value="filter.settlementWeightRoundingRules"
                      @parentCallBack="p=>{filter.settlementWeightRoundingRules=p.value}"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('FbaChannel.activeState')">
                    <cargo-advance-select
                      no="active"
                      :select-type="selectTypeNames.local_cache_FbaJobConstants$CHANNEL_ACTIVE_STATE"
                      filterable
                      style="width:128px"
                      :clearable="true"
                      :default-value="filter.active"
                      @parentCallBack="p=>{filter.active=p.value}"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="9300027"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            @gridReady="onGridReady"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            v-show="total>0"
            config-module="9300027"
            :total="total"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            @pagination="toQuery"
          />
        </div>
      </div>
    </div>
    <!-- 编辑弹窗 -->
    <fba-channel-edit-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      :fba-channel="editDialog.fbaChannel"
      :look="editDialog.look"
      @saveCallBack="editDialog.saveCallBack"
      @close="editDialog.visible=false"
    />
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getUserInfo } from '@/utils/auth'
import { getLoading } from '@/utils/utilBaseElement'
import { exportExcel, exportPdf } from '@/utils/tableDataExportUtils'
import ColumnUtils from '@/utils/ColumnUtils'
import { getGridSelected, getGridSelectedIds } from '@/utils/agGrid'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import { deleteFbaChannel, getUsedFbaChannel, listFbaChannel, updateActiveState } from '@/api/Fba/fbaChannel'
import FbaChannelEditDialog from '@/views/cargo/v0/FBA/Channel/fbaChannelEditDialog'

export default {
  name: 'FBAChannel',
  components: {
    cargoAdvanceSelect,
    cargoUserSelect,
    FbaChannelEditDialog
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      showAdv: false,
      simQueryPlaceholder: this.$t('FbaChannel.simQueryPlaceholder'),
      baseFilter: {
        tenantId: 0,
        likeName: '',
        shippingType: '',
        destinationDistribution: '',
        chargingMethod: '',
        cargoTypeList: [],
        settlementWeightRoundingRules: '',
        createdBy: '',
        beginDate: '',
        endDate: '',
        pageNum: 1,
        pageSize: 50,
        active: ''
      },
      filter: {
        tenantId: 0,
        likeName: '',
        shippingType: '',
        destinationDistribution: '',
        chargingMethod: '',
        cargoTypeList: [],
        settlementWeightRoundingRules: '',
        createdBy: '',
        beginDate: '',
        endDate: '',
        pageNum: 1,
        pageSize: 50,
        active: ''
      },
      total: 0,
      selectedData: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        context: {
          componentParent: this
        },
        onCellFocused: (event) => {
          this.onGridCellFocused(event)
        },
        onRowClicked: this.onRowSelected,
        onRowSelected: this.onRowSelected,
        onRowDoubleClicked: this.onRowDoubleClicked,
        getContextMenuItems: () => {
          const exportExcelText = this.$t('CargoMsg.Cargo_ExcelExport')
          const exportPdfText = this.$t('CargoMsg.Cargo_DataExportPDF')
          return [
            { name: exportExcelText, action: () => this.exportExcelHandler() },
            { name: exportPdfText, action: () => this.exportPdfHandler() }
          ]
        }
      },
      columnDefs: [
        {
          headerName: '',
          field: '',
          width: 65,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        }, {
          headerName: this.$t('FbaChannel.channelName'),
          field: 'channelName',
          width: 100
        }, {
          headerName: this.$t('FbaChannel.shippingType'),
          field: 'shippingType',
          width: 100,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.local_cache_FbaJobConstants$SHIPPING_TYPES, 'code', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('FbaChannel.destinationDistribution'),
          field: 'destinationDistribution',
          width: 100,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.local_cache_FbaJobConstants$ORDER_DESTINATION_DISTRIBUTION_TYPES, 'code', params.value + '', 'chineseName')
          }
        }, {
          headerName: this.$t('FbaChannel.chargingMethod'),
          field: 'chargingMethod',
          width: 100,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.local_cache_FbaJobConstants$CHARGING_METHODS, 'code', params.value?.toString(), 'chineseName')
          }
        }, {
          headerName: this.$t('FbaChannel.bubbleCountingRatio'),
          field: 'bubbleCountingRatio',
          width: 100
        }, {
          headerName: this.$t('FbaChannel.acceptableGoods'),
          field: 'acceptableGoods',
          width: 200,
          valueFormatter: (params) => {
            const acceptableGoodsCodeList = params.value.split(',')
            const acceptableGoods = []
            for (const each of acceptableGoodsCodeList) {
              const acceptableGoodsTag = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CargoType, 'code', each, 'chineseName')
              if (acceptableGoodsTag) {
                acceptableGoods.push(acceptableGoodsTag)
              }
            }
            return acceptableGoods.join(',')
          }
        }, {
          headerName: this.$t('FbaChannel.bubbleSplittingRatio'),
          field: 'bubbleSplittingRatio',
          width: 100
        }, {
          headerName: this.$t('FbaChannel.multipleBoxesCalculationRules'),
          field: 'multipleBoxesCalculationRules',
          width: 100,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.local_cache_FbaJobConstants$MULTIPLE_BOXES_CALCULATION_RULES, 'code', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('FbaChannel.settlementWeightRoundingRules'),
          field: 'settlementWeightRoundingRules',
          width: 100,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.local_cache_FbaJobConstants$SETTLEMENT_WEIGHT_ROUNDING_RULES, 'code', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('FbaJob.CreatedBy'),
          field: 'createdBy',
          width: 120,
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('Menu.CreateDate'),
          field: 'dateCreated',
          width: 140,
          hide: true
        }, {
          headerName: this.$t('FbaChannel.activeState'),
          field: 'active',
          width: 80,
          cellRenderer: (params) => {
            return params.value ? this.$t('FbaChannel.enable') : this.$t('FbaChannel.disable')
          }
        }
      ],
      rowData: [],
      gridApi: null,
      tenantId: 0,
      editDialog: {
        visible: false,
        title: '',
        fbaChannel: null,
        look: false,
        saveCallBack: () => {
        }
      }
    }
  },
  created() {
    const user = getUserInfo()
    this.tenantId = user.tenantId
    this.toQuery()
  },
  methods: {
    resetSearch() {
      Object.assign(this.filter, this.baseFilter)
    },
    onGridCellFocused(event) {
      if (!event) return
      this.selectedData = null
      if (this.gridApi && event.column) {
        this.gridApi.forEachNode(node => {
          if (node && node.rowIndex === event.rowIndex && node.data) {
            const nodeChannel = node.data
            if (nodeChannel.uuid) this.selectedData = nodeChannel
          }
        })
      }
    },
    // 行首多选框勾选事件
    onRowSelected(event) {
      if (!event.data || !event.data.uuid) {
        return false
      }
      this.selectedData = event.data
      return true
    },
    onRowDoubleClicked(event) {
      if (!this.onRowSelected(event)) return
      this.lookChannel()
    },
    lookChannel() {
      const cell = this.gridApi.getFocusedCell()
      const row = cell ? this.rowData[cell.rowIndex] : null
      if (row) {
        this.editDialog.fbaChannel = row
        this.editDialog.title = this.$t('FbaChannel.lookChannel')
        this.editDialog.visible = true
        this.editDialog.look = true
      }
    },
    onGridReady(p) {
      this.gridApi = p.api
    },
    upOrDownSearchCondition() {
      this.showAdv = !this.showAdv
    },
    keyWordBlur() {
      this.simQueryPlaceholder = this.$t('FbaChannel.simQueryPlaceholder')
    },
    toQuery() {
      const loading = getLoading()
      this.filter.tenantId = this.tenantId
      const params = { ...this.filter }
      listFbaChannel(params).then(res => {
        this.rowData = res.data.list
        this.filter.pageNum = res.data.pageNum
        this.filter.pageSize = res.data.pageSize
        this.total = Number(res.data.total)
        this.selectedData = null
      }).finally(() => loading.close())
    },
    newHandler() {
      this.editDialog.title = this.$t('FbaChannel.newChannel')
      this.editDialog.visible = true
      this.editDialog.fbaChannel = null
      this.editDialog.look = false
      this.editDialog.saveCallBack = this.addCallBackHandler
    },
    editHandler() {
      const cell = this.gridApi.getFocusedCell()
      const row = cell ? this.rowData[cell.rowIndex] : null
      if (!row) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.editDialog.fbaChannel = row
      this.editDialog.title = this.$t('FbaChannel.editChannel')
      this.editDialog.visible = true
      this.editDialog.look = false
      this.editDialog.saveCallBack = this.addCallBackHandler
    },
    async toDelete() {
      const selectedList = getGridSelected(this.gridOptions)
      const channelNameList = []
      selectedList.forEach(e => channelNameList.push(e.channelName))
      const data = { channelNameList: channelNameList, tenantId: this.tenantId }
      let usedFlag = false
      let loading = getLoading()
      await getUsedFbaChannel(data).then(res => {
        const data = res.data
        if (data && data.length > 0) {
          usedFlag = true
          this.$message.warning(this.$t('FbaChannel.cannotDelete'))
        }
      }).finally(() => loading.close())
      if (usedFlag) {
        return
      }
      getGridSelectedIds(this.gridOptions, 'uuid').then(uuidList => {
        return this.$confirm(this.$t('Message.DeleteTheSelectedRecord'), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          type: 'warning'
        }).then(() => {
          const data = { uuidList: uuidList, tenantId: this.tenantId }
          loading = getLoading()
          return deleteFbaChannel(data)
        }).catch(() => {
          return Promise.reject(this.$t('Message.DeletionCancelled'))
        })
      }).then(res => {
        if (res.ok) {
          loading.close()
          this.toQuery()
          this.$message({
            type: 'success',
            message: this.$t('Message.DeleteSucceeded')
          })
        } else {
          this.$message({
            type: 'info',
            message: this.$t('Message.DeleteFail')
          })
        }
      }).finally(() => loading.close())
    },
    toActive(op) {
      const selectedList = getGridSelected(this.gridOptions)
      const uuidList = []
      let canActive = false
      for (const channel of selectedList) {
        uuidList.push(channel.uuid)
        if (op === 'enable') {
          if (!channel.active) {
            canActive = true
          }
        } else {
          if (channel.active) {
            canActive = true
          }
        }
      }
      if (!canActive) {
        this.$message.warning(this.$t('FbaChannel.cannotActive'))
        return
      }
      const data = { uuidList: uuidList, activeOp: op, tenantId: this.tenantId }
      const loading = getLoading()
      updateActiveState(data).then(res => {
        if (res.ok) {
          loading.close()
          this.toQuery()
          this.$message({
            type: 'success',
            message: op === 'enable' ? this.$t('FbaChannel.enableSucceed') : this.$t('FbaChannel.disableSucceed')
          })
        } else {
          this.$message({
            type: 'info',
            message: this.$t('Message.EditedFailMessage')
          })
        }
      }).finally(() => loading.close())
    },
    addCallBackHandler() {
      this.toQuery()
    },
    exportExcelHandler() {
      const columnDefs = []
      this.columnDefs.forEach(column => columnDefs.push({ colDef: column }))
      exportExcel('FBA渠道', this.rowData, columnDefs)
    },
    exportPdfHandler() {
      const columnDefs = []
      this.columnDefs.forEach(column => columnDefs.push({ colDef: column }))
      exportPdf('FBA渠道', this.rowData, columnDefs)
    }
  }
}
</script>

<style lang="scss">
#app {
  .city .app-main-page {
    height: calc(100vh - 100px);
  }

  .hasTagsView {
    .city .app-main-page {
      height: calc(100vh - 130px);
    }
  }
}
</style>
